import { render } from "./PoweredByStripe.vue?vue&type=template&id=4bcee535"
const script = {}

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__